module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_enpgames_m2.9c71e80fea5a241ff1784ad4d8e00a74.png";